import {
  BACKOFFICETRANSACTIONS_SORT_KEYS,
  BACKOFFICETRANSACTIONS_SORT_TYPES,
  backofficeTransactionsAssetFilterConstants,
  backofficeTransactionsQuickFilterConstants,
  sortKeys,
} from '../../pages/BackofficeTransactions/backofficeTransactionsConstants';
import {
  getFilterPayloadValues,
  getLocalDateFilterValue,
  isDateWithinRange,
} from '../../helpers/filterDate';
import { sortItemsByConfig } from '../../helpers/tableSort';
import * as types from './bo_transactionActionTypes';

const initialState = {
  backofficeTransactions: null,
  filteredBackofficeTransactions: null,
  backofficeTransactionsSortData: {
    sortType: BACKOFFICETRANSACTIONS_SORT_TYPES.DESCENDING,
    sortKey: BACKOFFICETRANSACTIONS_SORT_KEYS.CREATE_DATE,
  },
  quickFilter: 1,
  assetFilter: 1,
  error: {
    type: null,
    data: null,
  },
  success: null,
};

export const backofficeTransactionReducer = (state = initialState, action) => {
  const sortBackofficeTransactionsByCurrentSort = (
    transactions = [],
    sortData = state.backofficeTransactionsSortData
  ) => sortItemsByConfig(
    transactions,
    sortData,
    sortKeys,
    BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
  );

  switch (action.type) {
    case types.TRANSACTION_DATA:
      return {
        ...state,
        success: action?.payload?.result ? Object.assign({}, action.payload.result) : null,
      };
    case types.TRANSACTION_ERROR:
      return {
        ...state,
        error: {
          type: types.TRANSACTION_ERROR,
          data: action.payload,
        },
      };
    case types.GET_BACKOFFICETRANSACTIONS_DATA:
      let backofficeTransactions = action.payload.result
      return {
        ...state,
        backofficeTransactions: backofficeTransactions ?
          sortBackofficeTransactionsByCurrentSort(backofficeTransactions) :
          null,
      };

    case types.GET_BACKOFFICETRANSACTIONS_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_BACKOFFICETRANSACTIONS_ERROR,
          data: action.payload,
        },
      };
    case types.FILTER_BACKOFFICETRANSACTIONS:
      function filterBackofficeTransactions(payload) {
        const { searchText, startDate, endDate } = getFilterPayloadValues(payload);
        const filteredBackofficeTransactions = [];

        let tempBackofficeTransactionsForFilter = state.backofficeTransactions || [];

        if (state.quickFilter === backofficeTransactionsQuickFilterConstants.TRUE) {
          tempBackofficeTransactionsForFilter = 
          tempBackofficeTransactionsForFilter.filter((t) => t.transaction_status === true);
        } else if (state.quickFilter === backofficeTransactionsQuickFilterConstants.FALSE) {
          tempBackofficeTransactionsForFilter =
           tempBackofficeTransactionsForFilter.filter((t) => t.transaction_status === false);
        }

        if (state.assetFilter === backofficeTransactionsAssetFilterConstants.TOKEN) {
          tempBackofficeTransactionsForFilter =
            tempBackofficeTransactionsForFilter.filter((t) => t.asset_type === 'token');
        } else if (state.assetFilter === backofficeTransactionsAssetFilterConstants.NFT) {
          tempBackofficeTransactionsForFilter =
            tempBackofficeTransactionsForFilter.filter((t) => t.asset_type === 'nft');
        }


        if (tempBackofficeTransactionsForFilter) {
          for (const fBackofficeTransactions of tempBackofficeTransactionsForFilter) {
            const matchesSearch = !searchText ||
              fBackofficeTransactions?.transaction_hash?.toString()
                .toLowerCase().includes(searchText) ||
              fBackofficeTransactions?.project_name?.toString()
                .toLowerCase().includes(searchText) ||
              fBackofficeTransactions?.user_public_address?.toString()
                .toLowerCase().includes(searchText);
            const transactionDate = getLocalDateFilterValue(fBackofficeTransactions?.cdate);
            const matchesDate = isDateWithinRange(transactionDate, startDate, endDate);

            if (
              matchesSearch &&
              matchesDate
            ) {
              filteredBackofficeTransactions.push(fBackofficeTransactions);
            }
          }

          return filteredBackofficeTransactions;
        }
      }

      let filteredBackofficeTransactions = null;
      filteredBackofficeTransactions = 
      filterBackofficeTransactions(action?.payload);

      return {
        ...state,
        filteredBackofficeTransactions: filteredBackofficeTransactions ? 
        [...filteredBackofficeTransactions] : null,
      };
    case types.SET_BACKOFFICETRANSACTIONS_SORT_DATA:
      return {
        ...state,
        backofficeTransactionsSortData: { ...action.payload },
      };
    case types.SORT_BACKOFFICETRANSACTIONS:
      const tempBackofficeTransactionsForSorting = 
      state.filteredBackofficeTransactions?.length
        ? state.filteredBackofficeTransactions
        : state.backofficeTransactions;
      const sortedBackofficeTransactions =
        sortBackofficeTransactionsByCurrentSort(tempBackofficeTransactionsForSorting);

      if (state.filteredBackofficeTransactions?.length) {
        return {
          ...state,
          filteredBackofficeTransactions: sortedBackofficeTransactions ?
           [...sortedBackofficeTransactions] : null,
        };
      }
      return {
        ...state,
        backofficeTransactions: sortedBackofficeTransactions ?
         [...sortedBackofficeTransactions] : state.backofficeTransactions,
      };

    case types.UPDATE_QUICK_FILTER:
      return {
        ...state,
        quickFilter: action?.payload,
      };
    case types.UPDATE_ASSET_FILTER:
      return {
        ...state,
        assetFilter: action?.payload,
      };
    default:
      return state;
  }
};
